import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PropertyAboutSectionComponent } from './property-about-section.component';
import { TgInputModule, TgSelectModule } from '@trademe/tangram';
import { PropertyRentalAttributeSectionModule } from '../../residential-for-rent/property-rental-attribute-section/property-rental-attribute-section.module';
import { DraftValidationModule } from '@classifieds-sell/shared';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgInputModule,
        TgSelectModule,
        PropertyRentalAttributeSectionModule,
        DraftValidationModule
    ],
    declarations: [PropertyAboutSectionComponent],
    exports: [PropertyAboutSectionComponent]
})
export class PropertyAboutSectionModule {}
